import { UserApi } from '../../../api';
import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { addProfileUpcomingMedicalLeaveRequests } from '../../../store/slices/user-profile.slice';

const useHttpGetUpcomingMedicalLeaveRequestsForUserOnMount = (userSub: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = userApi.upcomingMedicalLeaveRequestsForUser({
        params: { userSub },
        onSuccess: res => {
            dispatch(addProfileUpcomingMedicalLeaveRequests(res.body));
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { isReady, exec };
};

export default useHttpGetUpcomingMedicalLeaveRequestsForUserOnMount;
